var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mainBanner"},[(_vm.banner)?_c('order-banner'):_vm._e(),_c('v-container',{staticClass:"pr-0 pl-0 pt-0 pb-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }